// extracted by mini-css-extract-plugin
module.exports = {"label":"GeoPopup_label__lvWab","checkboxInput":"GeoPopup_checkboxInput__gHSMY","button":"GeoPopup_button__zPiS7"};